import React from 'react';
import styled, { css } from 'styled-components';
import { observer } from 'mobx-react-lite';

import { MenuConsumer } from './Menu';

const MenuItem = observer((props) => {
  function handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (props.onClick && !props.disabled) {
      props.onClick(event);
    }
  }

  return (
    <MenuConsumer>
      {({ open, close }) => (
        <StyledMenuItem
          {...props}
          open={open}
          onClick={(event) => {
            close();
            handleClick(event);
          }}
        />
      )}
    </MenuConsumer>
  );
});

const StyledMenuItem = styled.div`
  position: relative;
  padding: 10px;
  transition: all 0.15s ease-out;
  display: flex;
  align-items: center;
  border-radius: 4px;
  color: ${(p) => p.theme.purple80};
  display: ${(p) => (p.open ? 'block' : 'none')};

  :hover {
    color: ${(p) => p.theme.purple100};
    background-color: ${(p) => p.theme.purpleTrans5};
    cursor: pointer;
  }

  ${(p) =>
    p.disabled &&
    css`
      :hover {
        color: #6b6b6b;
        background-color: ${(p) => p.theme.white};
        cursor: initial;
      }
      opacity: 0.5;
    `};
`;

export default MenuItem;
